import Vue from 'vue';
import _ from 'lodash';
import tooltip from '@/mixins/components/tooltip';

export default Vue.component('edit-text-swapper', {
  template: require('./template.html'),
  name: 'edit-text-swapper',
  components: {
    tooltip,
  },
  props: ['droplet', 'show-edit-bubble'],
  data() {
    return {
      effects: [
        'none',
        'fade',
        'rise',
        'zoom',
      ],
      maxAllowedGroups: 6,
      items: {},
      bounceTime: 1000,
    };
  },
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValues();
      }
    },
  },
  methods: {
    setInitialValues() {
      _.forEach(this.droplet.groups, (group, index) => {
        this.$set(this.items, index, false);
      });
    },
    setNumber({ e, key, group }) {
      this.$store.dispatch('setDropletVal', {
        drp: group,
        key,
        val: e.target.value || 0,
      });
      this._debounce(() => this.$emit('bounce-plugin'), this.bounceTime);
    },
    setCenter({ e, group }) {
      const checked = e.currentTarget.checked;
      this.$store.dispatch('setDropletVal', {
        drp: group,
        key: 'center',
        val: checked,
      });
      this._debounce(() => this.$emit('bounce-plugin'), this.bounceTime);
    },
    setEffect(e, group) {
      this.$store.dispatch('setDropletVal', {
        drp: group,
        key: 'effect',
        val: e.target.value,
      });
      this._debounce(() => this.$emit('bounce-plugin'), this.bounceTime);
    },
    addItem({ group }) {
      this.$store.dispatch('runStateFn', {
        fn() {
          group.items.push('Text Here');
        },
      });
      this._debounce(() => this.$emit('bounce-plugin'), this.bounceTime);
    },
    setItem({ e, group, index }) {
      const value = this._getInputVal(e.target.value);
      this.$store.dispatch('runStateFn', {
        fn() {
          group.items.splice(index, 1, value);
        },
      });
      this._debounce(() => this.$emit('bounce-plugin'), this.bounceTime);
    },
    removeItem({ group, index }) {
      if (group.items.length > 1) {
        this.$store.dispatch('runStateFn', {
          fn() {
            group.items.splice(index, 1);
          },
        });
        this._debounce(() => this.$emit('bounce-plugin'), this.bounceTime);
      }
    },
    addGroup() {
      const droplet = this.droplet;
      if (droplet.groups.length < this.maxAllowedGroups) {
        this.$store.dispatch('runStateFn', {
          fn() {
            droplet.groups.push({
              effect: 'fade',
              pause: 3000,
              duration: 500,
              center: false,
              items: ['Line One', 'Line Two'],
            });
          },
        });
        this.setInitialValues();
        this._debounce(() => this.$emit('bounce-plugin'), this.bounceTime);
      }
    },
    removeGroup(index) {
      const droplet = this.droplet;
      if (droplet.groups.length > 1) {
        this.$store.dispatch('runStateFn', {
          fn() {
            droplet.groups.splice(index, 1);
          },
        });
        this.setInitialValues();
        this._debounce(() => this.$emit('bounce-plugin'), this.bounceTime);
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/text-swapper/components/_edit-options/index.js